import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { concatMap, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

@Injectable(
  {
    providedIn: 'root'
  }
)

export class AdalService {

  constructor(private authService: MsalService) {
    // Do Nothing
  }

  getGraphToken = (): Observable<string> => {

    const request = {
      scopes: ['https://graph.microsoft.com/User.ReadBasic.All'],
      account: this.authService.instance.getAllAccounts()[0],
    };

    return this.authService.acquireTokenSilent(request).pipe(
      concatMap((response) => {
        return of(response.accessToken)
      }),
      catchError(err => {
        if (err instanceof InteractionRequiredAuthError) {
          localStorage.clear();
          this.authService.loginRedirect({ scopes: ["openid", "profile", "User.Read"] });
        }
        return of('Auth Error');
      }));
  }

  getOneSiteToken = (): Observable<string> => {

    const request = {
      scopes: ['https://41ff26dc-250f-4b13-8981-739be8610c21/Covid19Compliance/user_impersonation'],
      account: this.authService.instance.getAllAccounts()[0]
    };

    return this.authService.acquireTokenSilent(request).pipe(
      concatMap((response) => {
        return of(response.accessToken)
      }));
  }
}
